import { InputComponent, PremiumCalculator } from '@/components';

export default {
  name: "Checkout",
  components:{
    InputComponent,
    PremiumCalculator
  },
};
